<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h3 class="text-black fw-semibold">Liste des commandes fournisseurs</h3>
      <div>
        <router-link :to="{ name: 'AddCommandeFournisseurPage' }"
          class="btn btn-primary" v-if="checkPermission('AddCommandeFournisseur')">
          <i class="fa fa-plus-circle position-relative me-1 fs-12"></i>
          Nouvelle commande
        </router-link>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Mot clé</label>
              <input v-model="searchTerm" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Référence ou fournisseur" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Statut</label>
              <select v-model="selectedStatut" class="form-select shadow-none fs-md-15 text-black">
                <option value="">Tous</option>
                <option :value="STATUT_EN_ATTENTE">En attente de validation</option>
                <option :value="STATUT_VALIDE">Validée</option>
                <option :value="STATUT_REJETE">Rejetée</option>
              </select>
            </div>
          </div>

          <div class="col-md-4" v-if="point_ventes.length > 1">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Filtrer par point de vente</label>
              <Multiselect v-model="point_vente" :options="point_ventes" :searchable="true" label="label"
                placeholder="Sélectionner un point de vente" />
            </div>
          </div>
        </div>
      </div>
      <hr>

      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Référence</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Date</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Fournisseur
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Poids total
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">Statut</th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="commande in commandes" :key="commande.id">
              <td class="shadow-none lh-1 fw-medium">{{ commande.refCom }}</td>
              <td class="shadow-none lh-1 fw-medium">{{ format_date(commande.dateComFrs) }}</td>
              <td class="shadow-none lh-1 fw-medium">{{ libelleFournisseur(commande.fournisseur) }}</td>
              <td class="shadow-none lh-1 fw-medium">{{ formatPoids(commande.poidsTotal) }}</td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge" :class="classeStatut(commande.statut)">{{ libelleStatut(commande.statut) }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">Actions</button>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('ViewCommandeFournisseur')">
                      <router-link :to="{ name: 'ViewCommandeFournisseurPage', params: { id: commande.id } }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                      </router-link>
                    </li>
                    <li v-if="checkPermission('DownloadBordereauCommandeFournisseur')">
                      <a href="javascript:void(0)" class="dropdown-item d-flex align-items-center"
                        @click="imprimerBordereau(commande)">
                        <i class="fa fa-print lh-1 me-8 position-relative top-1"></i>Bordereau
                      </a>
                    </li>

                    <template v-if="estEnAttente(commande)">
                      <li v-if="checkPermission('EditCommandeFournisseur')">
                        <router-link :to="{ name: 'EditCommandeFournisseurPage', params: { id: commande.id } }"
                          class="dropdown-item d-flex align-items-center">
                          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier
                        </router-link>
                      </li>
                      <li v-if="checkPermission('ValidateCommandeFournisseur')">
                        <a href="javascript:void(0)" class="dropdown-item d-flex align-items-center"
                          @click="valider(commande)">
                          <i class="fa fa-check lh-1 me-8 position-relative top-1"></i>Valider
                        </a>
                      </li>
                      <li v-if="checkPermission('RejectCommandeFournisseur')">
                        <a href="javascript:void(0)" class="dropdown-item d-flex align-items-center"
                          @click="rejeter(commande)">
                          <i class="fa fa-ban lh-1 me-8 position-relative top-1"></i>Rejeter
                        </a>
                      </li>
                      <li v-if="checkPermission('DeleteCommandeFournisseur')">
                        <a href="javascript:void(0)" class="dropdown-item d-flex align-items-center"
                          @click="supprimer(commande)">
                          <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>Supprimer
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="commandes.length === 0">
              <td colspan="6" class="text-center text-body-tertiary py-4">Aucune commande fournisseur trouvée.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import ApiService from "@/services/ApiService";
import { format_date, error, success } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import Swal from "sweetalert2";

const STATUT_EN_ATTENTE = "en attente de validation";
const STATUT_VALIDE = "valide";
const STATUT_REJETE = "rejete";

export default defineComponent({
  name: "ListCommandesFournisseurs",
  components: {
    Multiselect,
    PaginationComponent,
  },
  setup: () => {
    const commandes = ref<Array<any>>([]);

    const searchTerm = ref('');
    const selectedStatut = ref('');
    const point_vente = ref<any>('');
    const point_ventes = ref<Array<any>>([]);

    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    const charger = async () => {
      try {
        const pointVenteParam = point_vente.value ? point_vente.value : '';
        const url = `/commandesFournisseurs?page=${page.value}&limit=${limit.value}`
          + `&mot=${encodeURIComponent(searchTerm.value)}`
          + `&statut=${encodeURIComponent(selectedStatut.value)}`
          + `&pointvente=${pointVenteParam}`;

        const response = await ApiService.get(url);
        const resultat = response.data.data;

        commandes.value = resultat.data;
        totalPages.value = resultat.totalPages;
        limit.value = resultat.limit;
        totalElements.value = resultat.totalElements;
      } catch (err) {
        //
      }
    };

    const handlePaginate = ({ page_, limit_ }: any) => {
      page.value = page_;
      if (limit_) {
        limit.value = limit_;
      }
      charger();
    };

    // Rechargement (avec petite attente) quand un filtre change
    let minuteur: any = null;
    watch([searchTerm, selectedStatut, point_vente], () => {
      clearTimeout(minuteur);
      minuteur = setTimeout(() => {
        page.value = 1;
        charger();
      }, 300);
    });

    // ----- Affichage -----
    const estEnAttente = (commande: any): boolean => {
      if (commande.statut === STATUT_EN_ATTENTE) {
        return true;
      } else {
        return false;
      }
    };

    const libelleStatut = (statut: string): string => {
      if (statut === STATUT_VALIDE) {
        return "Validée";
      } else if (statut === STATUT_REJETE) {
        return "Rejetée";
      } else {
        return "En attente de validation";
      }
    };

    const classeStatut = (statut: string): string => {
      if (statut === STATUT_VALIDE) {
        return "badge-success";
      } else if (statut === STATUT_REJETE) {
        return "badge-danger";
      } else {
        return "badge-warning";
      }
    };

    const libelleFournisseur = (f: any): string => {
      if (!f) {
        return '';
      }
      if (f.statut === 2 || f.statut === "2") {
        return `${f.sigle} - ${f.denomination}`;
      }
      if (f.nomFournisseur && f.prenomFournisseur) {
        return `${f.nomFournisseur} ${f.prenomFournisseur}`;
      }
      return `${f.denomination || f.nomFournisseur || ''}`;
    };

    const formatPoids = (poids: any): string => {
      return Number(poids || 0).toLocaleString('fr-FR', { maximumFractionDigits: 3 });
    };

    // ----- Actions -----
    const confirmer = async (texte: string, libelleBouton: string): Promise<boolean> => {
      const result = await Swal.fire({
        text: texte,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: libelleBouton,
        cancelButtonText: "Annuler",
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger"
        },
      });
      return result.isConfirmed;
    };

    const valider = async (commande: any) => {
      const confirme = await confirmer(`Vous êtes sur le point de valider la commande ${commande.refCom}.\nEtes-vous sûr ?`, "Valider");
      if (!confirme) {
        return;
      }
      try {
        const response = await ApiService.put(`/commandesFournisseurs/${commande.id}/valider`, {});
        success(response.data.message);
        charger();
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors de la validation de la commande");
      }
    };

    const rejeter = async (commande: any) => {
      const confirme = await confirmer(`Vous êtes sur le point de rejeter la commande ${commande.refCom}.\nEtes-vous sûr ?`, "Rejeter");
      if (!confirme) {
        return;
      }
      try {
        const response = await ApiService.put(`/commandesFournisseurs/${commande.id}/rejeter`, {});
        success(response.data.message);
        charger();
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du rejet de la commande");
      }
    };

    const supprimer = async (commande: any) => {
      const confirme = await confirmer(`Vous êtes sur le point de supprimer la commande ${commande.refCom}.\nEtes-vous sûr ?`, "Supprimer");
      if (!confirme) {
        return;
      }
      try {
        const response = await ApiService.delete(`/commandesFournisseurs/${commande.id}`);
        success(response.data.message);
        charger();
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors de la suppression de la commande");
      }
    };

    // Génère le bordereau PDF et l'ouvre dans un nouvel onglet
    const imprimerBordereau = async (commande: any) => {
      // L'onglet est ouvert tout de suite pour ne pas être bloqué par le navigateur
      const fenetre = window.open("", "_blank");

      try {
        const response = await ApiService.vueInstance.axios.get(
          `/commandesFournisseurs/${commande.id}/bordereau`,
          { responseType: "blob" }
        );

        const fichier = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(fichier);

        if (fenetre) {
          fenetre.location.href = url;
        } else {
          window.open(url, "_blank");
        }
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      } catch (err: any) {
        if (fenetre) {
          fenetre.close();
        }

        // Avec responseType "blob", le message d'erreur du serveur arrive aussi sous forme de Blob
        let message = "Erreur lors de la génération du bordereau";
        if (err.response?.data instanceof Blob) {
          try {
            const texte = await err.response.data.text();
            message = JSON.parse(texte).message || message;
          } catch {
            //
          }
        }
        error(message);
      }
    };

    onMounted(async () => {
      const ancienPointVente = point_vente.value;

      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];

      // Si le point de vente a changé, le watch recharge déjà la liste
      if (point_vente.value === ancienPointVente) {
        charger();
      }
    });

    return {
      commandes,
      searchTerm,
      selectedStatut,
      point_vente,
      point_ventes,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      checkPermission,
      format_date,
      formatPoids,
      libelleFournisseur,
      libelleStatut,
      classeStatut,
      estEnAttente,
      valider,
      rejeter,
      supprimer,
      imprimerBordereau,
      STATUT_EN_ATTENTE,
      STATUT_VALIDE,
      STATUT_REJETE,
    };
  },
});
</script>